<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <!-- <div class="tools" style="width: calc(100% - 80px); margin: 0 40px 10px 40px; border-bottom: 1px #eee solid; padding-bottom: 10px">
                <el-input v-model="search.project_name" placeholder="请输入申请人" size="small" style="width: 200px"></el-input>
                <el-input v-model="search.phone" placeholder="请输入联系电话" size="small" style="width: 200px"></el-input>
                <el-button type="primary" size="small" icon="el-icon-search" @click="doSearch">搜索</el-button>
              </div>-->
              <!-- <h3>拨款信息列表</h3> -->
              <p style="margin:0 20px 20px 20px; font-size:28px">
                <span
                  style="color:red"
                >{{tableData.data && tableData.data.length > 0?tableData.data[0].project_name:''}}</span> 申请拨款列表
              </p>
              <!-- <el-button v-if='addabled==1'  size="small" style="margin:0px 40px 10px;" type="primary" @click="addPayment">新增</el-button> -->
              <el-table
                :data="tableData.data"
                border
                size="small"
                style="width: calc(100% - 80px); margin: 0 40px 40px 40px"
              >
                <el-table-column label="序号" min-width="70" align="center">
                  <template slot-scope="scope">
                    <a
                      style="color:rgb(32, 153, 205);cursor: pointer;"
                      @click="edit"
                    >第{{scope.$index+1}} 批次</a>
                  </template>
                </el-table-column>

                <el-table-column label="项目名称" prop="project_name" min-width="150" align="center"></el-table-column>

                <el-table-column label="申请人" prop="apply_user_name" min-width="70" align="center"></el-table-column>

                <el-table-column label="申请拨款金额" prop="apply_money" min-width="100" align="center"></el-table-column>

                <el-table-column label="申请时间" prop="reg_time" min-width="100" align="center"></el-table-column>

                <el-table-column label="状态" min-width="100" align="center">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.status==2"
                      style="color:rgb(64, 158, 255);cursor:pointer"
                      @click="open(scope.row.audit_opinion)"
                    >{{scope.row.status_text}}</span>
                    <span v-else>{{scope.row.status_text}}</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" min-width="70" align="center">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button
                        type="primary"
                        icon="el-icon-edit"
                        size="mini"
                        :disabled="scope.row.status!=0&&scope.row.status!=2"
                        @click="edit"
                      >编辑</el-button>
                      <!-- <el-button
                      type="danger" 
                      icon="el-icon-delete"
                      style="padding: 5px 7px"
                      size="mini"
                      @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="margin-bottom: 20px;margin-right: 30px;float:right"
                background
                layout="prev, pager, next"
                @current-change="changePage"
                :current-page.sync="tableData.current_page"
                :page-size="pageSize"
                :total="tableData.total"
              ></el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../public/head";
import centerHead from "../public/center_head";
import leftMenu from "../public/menu";
import footDiv from "../public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data() {
    return {
      addabled: "",
      search: {},
      pageSize: 15,
      tableData: [],
      id: "",
      apply_pay_id: "",
      apply_pay_count: "",
      total_funds: ""
    };
  },
  methods: {
    open(value) {
      this.$confirm(value, "提示", {
        confirmButtonText: "确定"
      })
        .then(() => {})
        .catch(() => {});
    },
    addPayment() {
      this.$router.push({
        name: "hospitalProjectPayment",
        query: { id: this.id }
      });
    },
    edit() {
      this.$router.push({
        name: "hospitalProjectPayment",
        query: { id: this.id, apply_pay_id: this.apply_pay_id }
      });
    },

    //搜索
    doSearch(page = 1) {
      this.getProjectPaymentList(1, this.search);
    },
    changePage(page) {
      //更改页码
      this.getProjectPaymentList(page);
    },

    getProjectPaymentList(page = 1, search = {}) {
      //获取项目申请列表
      let data = {
        page: page,
        page_size: this.pageSize,
        project_type: 1,
        id: this.id
      };
      if (Object.keys(search).length > 0) {
        Object.assign(data, search);
      }
      this.$db.post(this.$db.config.publicPaymentList, data).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.addabled = this.$route.query.addabled; //是否可以新增
    this.apply_pay_id = this.$route.query.apply_pay_id;
    this.apply_pay_count = this.$route.query.apply_pay_count;
    this.total_funds = this.$route.query.total_funds;
    this.getProjectPaymentList(1);
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
   width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/payment_list.vue